'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Big;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _AbstractTextElement = require('./AbstractTextElement');

var _AbstractTextElement2 = _interopRequireDefault(_AbstractTextElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getClasses = function getClasses(className) {
  return (0, _classNames2.default)('private-big', className);
};

function Big(_ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['className']);

  return _react2.default.createElement(_AbstractTextElement2.default, _extends({}, rest, { className: getClasses(className) }));
}

Big.propTypes = _extends({}, _AbstractTextElement2.default.propTypes);

Big.defaultProps = _extends({}, _AbstractTextElement2.default.defaultProps);

Big.displayName = 'Big';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/elements/Big.js
// module id = 563
// module chunks = 171